import { type WorkspaceAgentMessagePill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';
import { type WorkspaceAgentMessagePillsById } from '~/components/v2/components/workspace/workspace-agent-panel/utils/buildWorkspaceAgentMessagePillsById';

export type FlattenWorkspaceAgentHistoryPillsParams = {
  pillsByMessageId: WorkspaceAgentMessagePillsById;
  previous: readonly WorkspaceAgentMessagePill[] | undefined;
};

/** Returns `previous` when the pill set is unchanged, so batch resolvers don't refetch per streamed token. */
export const flattenWorkspaceAgentHistoryPills = ({
  pillsByMessageId,
  previous,
}: FlattenWorkspaceAgentHistoryPillsParams): readonly WorkspaceAgentMessagePill[] => {
  const next = [...pillsByMessageId.values()].flat();

  if (previous && previous.length === next.length && previous.every((pill, index) => pill === next[index])) {
    return previous;
  }

  return next;
};
